import { authAxios } from "../config";
import { ApiKey } from "../endpoints";

export const MasterService = () => {
  const GetTechnologyCategories = async () => {
    try {
      const userRole = parseInt(localStorage.getItem("RoleId"), 10);
      const response = await authAxios.post(
        `${ApiKey.GetMasterTechnologiesCategory}`,
        { userRole },
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  const GetTechnologiesByCategoryId = async (categoryId) => {
    try {
      const response = await authAxios.post(`${ApiKey.GetMasterTechnologies}`, {
        categoryId,
        pageNo: 1,
        pageSize: 10,
      });
      return response.data;
    } catch (error) {
      console.log("Error fetching technologies", error);
      throw error;
    }
  };
  const GetMasterAllTechnologies = async () => {
    try {
      var response = await authAxios.get(`${ApiKey.GetMasterAllTechnologies}`);
      return response.data;
    } catch (error) {
      //console.log("Error in package details", error);
      return error;
    }
  };

  return {
    GetTechnologyCategories,
    GetTechnologiesByCategoryId,
    GetMasterAllTechnologies,
  };
};
